export default __webpack_public_path__ + "static/media/image26.e76cffa4.jpg";